export * from "./descriptions.component";
